import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  /**
   * 盘点任务
   */
  liquidationTaskList: {rows: [], total: 0}, // 列表
  liquidationTaskDetail: {}, // 详情
  liquidationTaskMark: 0,
  liquidationTasAddkMark: 0,
  supplierList: [], // 供应商
  goodsList: [], // 商品
  /**
   * 盘点损益单
   */
  liquidationLossList: {rows: []},
  liquidationLossMark: 0,
  lossDetailList: {baseInfo: {yilCode: '', yilTime: '', yilHandState: '', yitCode: ''}, goodsList: {rows: []}},
  /**
   * 盘点计划
   */
  liquidationPlanList: {}, // 计划列表
  cargoSpaceList: [], // 货位信息
  goodsLocationList: [], // 商品信息
  addPlanMark: 0,
  planSave: {},
  planDetail: {
    list: [],
    basis: {}
  }

}
const actions = {
  /**
   * 盘点任务
   */
  // 任务列表
  [types.GETTASKLIST] (context, params) {
    http.fetch('/api/inventoryTask/getInventoryTaskList', params).then(data => {
      context.commit(types.GETTASKLIST, data)
    })
  },
  // 供应商列表
  [types.GETSUPPLIERSELECT] (context, params) {
    http.fetch('/api/inventoryTask/getSupplierSelect', params).then(data => {
      context.commit(types.GETSUPPLIERSELECT, data)
    })
  },
  // 商品列表
  [types.GETGOODS] (context, params) {
    http.fetch('/api/inventoryTask/getGoods', params).then(data => {
      context.commit(types.GETGOODS, data)
    })
  },
  // 创建盘点任务
  [types.CRATEINVENTORYTASK] (context, params) {
    http.fetch('/api/inventoryTask/crateInventoryTask', params).then(data => {
      context.commit(types.CRATEINVENTORYTASK, data)
    })
  },
  // 获取盘点任务详情
  [types.GETINVENTORYTASKINFO] (context, params) {
    http.fetch('/api/inventoryTask/getInventoryTaskInfo', params).then(data => {
      context.commit(types.GETINVENTORYTASKINFO, data)
    })
  },
  // 接单
  [types.TAKEINVENTORYTASK] (context, params) {
    http.fetch('/api/inventoryTask/takeInventoryTask', params).then(data => {
      context.commit(types.TAKEINVENTORYTASK, data)
    })
  },
  // 取消
  [types.CANCELINVENTORYTASK] (context, params) {
    http.fetch('/api/inventoryTask/cancelInventoryTask', params).then(data => {
      context.commit(types.CANCELINVENTORYTASK, data)
    })
  },

  /**
   * 盘点损益单
   */
  // 获取列表
  [types.GETINVENTORYLOSSPAGE] (context, params) {
    http.fetch('/api/inventoryLoss/getInventoryLossPage', params).then(data => {
      context.commit(types.GETINVENTORYLOSSPAGE, data)
    })
  },
  // 获取详情信息
  [types.GETINVENTORYLOSSDETAIL] (context, params) {
    http.fetch('/api/inventoryLoss/getInventoryLossDetail', params).then(data => {
      context.commit(types.GETINVENTORYLOSSDETAIL, data)
    })
  },
  // 编辑 - 保持原系统库存 / 以差异值调整库存
  [types.INVENTORYHANDLE] (context, params) {
    http.fetch('/api/inventoryLoss/inventoryHandle', params).then(data => {
      context.commit(types.INVENTORYHANDLE, data)
    })
  },
  /**
   * 盘点计划
   */
  // 获取列表
  [types.GETLIQUIDATIONPLAN] (context, params) {
    http.fetch('/api/inventoryPlan/queryPlanPage', params).then(data => {
      context.commit(types.GETLIQUIDATIONPLAN, data)
    })
  },
  // 保存
  [types.SAVELIQUIDATIONPLAN] (context, params) {
    http.fetch('/api/inventoryPlan/saveLocationDetail', params).then(data => {
      context.commit(types.SAVELIQUIDATIONPLAN, data)
    })
  },
  // 获取详情
  [types.GETLIQUIDATIONPLANDETAIL] (context, params) {
    http.fetch('/api/inventoryLoss/inventoryHandle', params).then(data => {
      context.commit(types.GETLIQUIDATIONPLANDETAIL, data)
    })
  },
  // 货位详情
  [types.GETLOCATIONDETAIL] (context, params) {
    http.fetch('/api/inventoryPlan/locationDetail', params).then(data => {
      context.commit(types.GETLOCATIONDETAIL, data)
    })
  },
  // 商品、商品货位详情
  [types.GETLOCATIONGOODSDETAIL] (context, params) {
    http.fetch('/api/inventoryPlan/locationGoodsDetail', params).then(data => {
      context.commit(types.GETLOCATIONGOODSDETAIL, data)
    })
  },
  // 查询是否有未完成的盘点计划
  [types.ADDPLANCHECK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/inventoryPlan/addPlanCheck', params).then(data => {
        context.commit(types.ADDPLANCHECK, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //  验证任务是否未完成
  [types.CHECKTASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/inventoryPlan/addPlanCheck', params).then(data => {
        context.commit(types.ADDPLANCHECK, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看详情 planDetail
  [types.GETPLANDETAIL] (context, params) {
    http.fetch('/api/inventoryPlan/planDetail', params).then(data => {
      context.commit(types.GETPLANDETAIL, data)
    })
  }
}
const mutations = {
  /**
   * 盘点任务
   */
  // 盘点任务列表
  [types.GETTASKLIST] (state, data) {
    state.liquidationTaskList = {
      rows: data.obj.records,
      total: data.obj.total
    }
  },
  // 获取供应商列表
  [types.GETSUPPLIERSELECT] (state, data) {
    state.supplierList = data.obj
  },
  // 获取商品列表
  [types.GETGOODS] (state, data) {
    state.goodsList = data.obj
  },
  // 创建盘点任务
  [types.CRATEINVENTORYTASK] (state, data) {
    if (data.code === 200) {
      state.liquidationTasAddkMark = 1
    }
  },
  // 获取详情
  [types.GETINVENTORYTASKINFO] (state, data) {
    state.liquidationTaskDetail = data.obj
  },
  // 接单
  [types.TAKEINVENTORYTASK] (state, data) {
    if (data.code === 200) {
      state.liquidationTaskMark = 1
      vue.$message({
        message: '接单成功！',
        type: 'success'
      })
    } else if (data.code === 500) {
      state.liquidationTaskMark = 1
    }
  },
  // 取消
  [types.CANCELINVENTORYTASK] (state, data) {
    if (data.code === 200) {
      state.liquidationTaskMark = 1
      vue.$message({
        message: '已取消！',
        type: 'success'
      })
    } else if (data.code === 500) {
      state.liquidationTaskMark = 1
    }
  },

  /**
   * 盘点损益单
   */
  // 获取列表
  [types.GETINVENTORYLOSSPAGE] (state, data) {
    state.liquidationLossList = data
  },
  // 获取详情信息
  [types.GETINVENTORYLOSSDETAIL] (state, data) {
    data = data.obj
    data.goodsList = {rows: data.goodsList}
    state.lossDetailList = {
      baseInfo: data.baseInfo || state.lossDetailList.baseInfo,
      goodsList: data.goodsList
    }
  },
  // 编辑 - 保持原系统库存 / 以差异值调整库存
  [types.INVENTORYHANDLE] (state, data) {
    state.liquidationLossMark = 1
    if (data.code !== 200) return
    vue.$message.success('操作成功')
  },
  /**
   * 盘点计划
   */
  // 列表
  [types.GETLIQUIDATIONPLAN] (state, data) {
    state.liquidationPlanList = {
      rows: data.obj.records,
      total: data.obj.total
    }
  },
  // 保存
  [types.SAVELIQUIDATIONPLAN] (state, data) {
    if (data.code === 200 && !data.obj) {
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
      state.addPlanMark = 1
    } else {
      state.planSave = data.obj
      console.log(state.planSave)
    }
  },
  // 详情
  [types.GETLIQUIDATIONPLANDETAIL] (state, data) {
  },
  // 货位信息
  [types.GETLOCATIONDETAIL] (state, data) {
    state.cargoSpaceList = data.obj
  },
  // 商品、商品货位信息
  [types.GETLOCATIONGOODSDETAIL] (state, data) {
    state.goodsLocationList = data.obj
  },
  [types.ADDPLANCHECK] (state, data) {
  },
  // 查看详情
  [types.GETPLANDETAIL] (state, data) {
    if (data.code === 200) {
      state.planDetail = {
        list: data.obj.list,
        basis: data.obj.basis
      }
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/liquidationManage/index.js